//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import { groupBy, map, orderBy, capitalize, cloneDeep } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
//  -- Components ---------------------
import { Col, Row, Select, Spin } from "antd";
import SentryWrap from "components/Sentry";
//  -- Constants ----------------------
import COLOR from "utils/constants/color";

//  -- Features -----------------------

//  -- Thunks -------------------------
import { DownloadOutlined } from '@ant-design/icons';
import Loading from "components/Loading";
import moment from "moment-timezone";
import { useReactToPrint } from 'react-to-print';
import { useAllBook } from "store/books/selectors";
import { handleGetOrgClasses } from "store/classes/thunks";
import { useExams } from "store/exams/selectors";
import { useBookUsesGraphData, useContentExamGraphData, useDistrictDashboardInfo, useExamGraphData } from 'store/organizations/selectors';
import { handleContentExamBooks, handleContentExamGraphData, handleListApExamGraphData, handleListDashboardInfo, handleListExamGraphData, handleListSublimentUsedbookUsed, handleListbookUsed } from "store/organizations/thunks";
import { handleListUserBooks } from "store/userBooks/thunks";
import { DistrictBg } from "utils/assets/images";
import { addPrintableClass, removePrintableClass } from "utils/methods/textMethod";
import * as Sentry from '@sentry/react';
import { Tabs } from 'antd';
import { NoAssignmentGraph } from "utils/assets/images";
import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  LabelList,
  Sector
} from 'recharts';
const { Option } = Select;
const MENU = [
  {
    label: "See schools",
    value: "see_schools",
  }
];
const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

export const Wrapper = styled.div`
  height: 100%;
  width: calc(100% + 50px);
  margin-left: -25px;
  background-image: url(${DistrictBg});
  background-position: 100% 100%;
  background-size: cover;
`;
//-----------new component --------------//


const StatsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 17px;
  gap: 2%;
  flex-wrap: wrap;
  @media (max-width: 590px) {
    width: 100%;
    margin-bottom: 22px;
    gap: 5%;
  }
`;


const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bgColor || '#f5f5f5'};
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 23.50%; // Adjust width as needed
  height: 120px; // Adjust height as needed
  @media (max-width: 590px) {  
    width: 47.5%;
    margin-bottom: 4.5%;
  }
`;

const Title = styled.div`
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
`;

const Number = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #333;
`;

const ChartContainer = styled.div`
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  position: relative;
`;
const ChartContainerLoader = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 9999;
`;
const ChartContainerPi = styled.div`
  padding: 24px 10px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  position: relative;

`;
const ChartContainerCe = styled.div`
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  position: relative;

`;

const GraphRow = styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media print {
    flex-direction: column;
  }
`;
const GraphCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 767px) {
    justify-content: flex-start;
  }
  @media print {
    justify-content:flex-start;
  }
`;
const DownloadDiv = styled.div`
   display: flex;
   justify-content: flex-end;
`
const DownButton = styled.button`
    border: none;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;
    margin-right: 16px;
    height: 40px;
    background: ${COLOR.green200};
    color: #fff;
    margin-top: 20px;
    padding-left: 12px;
    padding-right: 12px;
    &:hover {
      background: ${COLOR.green1000};
    }
`;
const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
  gap: 20px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #333;
`;

const ColorDot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  display: inline-block;
`;

const renderActiveShape = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  fill,
  payload,
  percent,
  value,
}) => {
  const RADIAN = Math.PI / 180;
  const sin = Math.sin(-RADIAN * (midAngle ?? 1));
  const cos = Math.cos(-RADIAN * (midAngle ?? 1));
  const sx = (cx ?? 0) + ((outerRadius ?? 0) + 10) * cos;
  const sy = (cy ?? 0) + ((outerRadius ?? 0) + 10) * sin;
  const mx = (cx ?? 0) + ((outerRadius ?? 0) + 16) * cos;
  const my = (cy ?? 0) + ((outerRadius ?? 0) + 16) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  const payloadName = payload.name;
  const finalName = payloadName.length < 20 
  ? payloadName 
  : payloadName.substring(0, 15) + "...";

  return (
    <g>
      <text x={cx} y={cy}  textAnchor="middle"  fill={fill}>
        { finalName }
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={(outerRadius ?? 0) + 6}
        outerRadius={(outerRadius ?? 0) + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      {/* <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`PV ${value}`}</text> */}
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey}  textAnchor={textAnchor} fill="#999">
        {`(Usage ${((percent ?? 1) * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

const chartOptions = {
  chart: {
    type: 'line',
    height: 250
  },
  title: {
    text: ''
  },
  xAxis: {
    categories: ['Nov Low', 'Nov Mid', 'Nov High', 'Inter Low', 'Inter Mid', 'Inter High', 'Adv Low', 'Adv Mid', 'Adv High']
  },
  yAxis: {
    title: {
      text: ''
    }
  },
  series: [{
    type: 'scatter',
    data: []
  }],
  plotOptions: {
    scatter: {
      marker: {
        radius: 5,
        symbol: 'circle'
      }
    }
  },
  tooltip: {
    formatter: function () {
      return '<b>' + this.x + '</b><br>Value: <b>' + this.y + '</b>';
    }
  }
};
const ORDERED_DATA = ["NOVICE LOW", "NOVICE MID", "NOVICE HIGH", "INTER LOW", "INTER MID", "INTER HIGH", "ADV LOW", "ADV MID", "ADV HIGH"]
const initialgraphData = {
  "ADV HIGH": 0,
  "ADV MID": 0,
  "ADV LOW": 0,
  "INTER HIGH": 0,
  "INTER MID": 3,
  "INTER LOW": 0,
  "NOVICE HIGH": 0,
  "NOVICE MID": 0,
  "NOVICE LOW": 0
}

const OverallProficiencyChart = ({ currentOrg }) => {
  const [selectedExam, setSelectedExam] = useState('1');
  const [selectedSchool, setSelectedSchool] = useState('high');
  const [activeSession, setActiveSession] = useState(moment().get("month") < 7 ? downcomming_year : upcomming_year)
  const dispatch = useDispatch()
  const [graphData, setGraphData] = useState(initialgraphData)
  const [loading, setLoading] = useState(false)
  const examGraphData = useExamGraphData()
  const chartRef = useRef(null);

  async function hasData() {
    return examGraphData && Object.keys(examGraphData.config).length > 0
  }
  useEffect(() => {
    if (hasData()) {
      const { config, data } = examGraphData;
      setGraphData(data)
    }
  }, [examGraphData])
  const chartData = useMemo(() => {
    const keys = orderBy(Object.keys(graphData), [element => ORDERED_DATA.indexOf(element)]);
    return keys.map(key => ({ name: capitalize(key), value: graphData[key] }))
  }, [graphData])
  async function fetchData() {
    setLoading(true)
    try {
      const data = await dispatch(handleListExamGraphData({
        "session": activeSession,
        "exam_type": selectedExam,
        "school_level": selectedSchool,
        "id": currentOrg.id
      }))
      if (typeof data === "object") {
        setGraphData(data)
      } else {
        setGraphData(initialgraphData)
      }
    } catch (error) {
      Sentry.captureException(`476 Error in fetchData: ${error}`);
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [dispatch, selectedExam, selectedSchool, activeSession, currentOrg])

  useEffect(() => {
    return () => {
      // Cleanup function to destroy chart on unmount
      if (chartRef.current && chartRef.current.chart) {
        chartRef.current.chart.destroy();
      }
    };
  }, []);

  const chart = useMemo(() => (
    <ResponsiveContainer width="100%" height={300}>
      <ScatterChart margin={{ top: 10, right: 20, left: 10, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} tickMargin={25} angle={-45} textAnchor="end" height={60} />
        <YAxis dataKey="value" tick={{ fontSize: 12 }} domain={[0, 'auto']} allowDecimals={false} label={{ value: 'Count', angle: -90, position: 'insideLeft', fontSize: 12 }} />
        <Tooltip formatter={(value) => [value, 'Value']} contentStyle={{ fontSize: '12px' }} labelStyle={{ fontWeight: 'bold' }} />
        <Legend wrapperStyle={{ fontSize: '12px', paddingTop: 20 }} />
        <Scatter name="Proficiency" data={chartData} fill="#8884d8" shape="circle" isAnimationActive={false} />
      </ScatterChart>
    </ResponsiveContainer>
  ), [chartData])

  const exams = useExams()
  return (
    <ChartContainer >
      {loading && <ChartContainerLoader><Spin size="large" /></ChartContainerLoader>}
      <GraphRow>
        <Col span={12} xl={6}>
          <Title>Overall Proficiency</Title>
        </Col>
        <GraphCol span={12} md={24} lg={24} xl={18} >
          <Select defaultValue={selectedExam} style={{ width: 120, marginBottom: '20px' }} onChange={v => {
            setSelectedExam(v)
          }} getPopupContainer={(trigger) => trigger.parentNode}>
            <Option value="1">Exam1</Option>
            <Option value="2">Exam2</Option>
            <Option value="3">Exam3</Option>
            <Option value="combine">Combine</Option>
          </Select>
          <Select defaultValue={selectedSchool} style={{ width: 120, marginBottom: '20px' }} onChange={v => setSelectedSchool(v)} getPopupContainer={(trigger) => trigger.parentNode}>
            <Option value="high">High School</Option>
            <Option value="middle">Middle School</Option>
          </Select>
          <Select defaultValue={activeSession} style={{ width: 120, marginBottom: '20px' }} onChange={v => setActiveSession(v)} getPopupContainer={(trigger) => trigger.parentNode}>
            {map(Object.keys(groupBy(exams, "session")), x => <Option value={x} key={x}>{x}</Option>)}
          </Select>
        </GraphCol>
      </GraphRow>
      {chart}
    </ChartContainer>
  );
};

const initialAPgraphData = [
  {
      "label": "Score 1",
      "value": 0
  },
  {
      "label": "Score 2",
      "value": 0
  },
  {
      "label": "Score 3",
      "value": 0
  },
  {
      "label": "Score 4",
      "value": 0
  },
  {
      "label": "Score 5",
      "value": 0
  }
]
const ApchartOptions = {
  chart: {
    type: 'line',
    height: 250
  },
  title: {
    text: ''
  },
  xAxis: {
    categories: ['Score 1', 'Score 2', 'Score 3', 'Score 4', 'Score 5']
  },
  yAxis: {
    title: {
      text: ''
    }
  },
  series: [{
    type: 'scatter',
    data: []
  }],
  plotOptions: {
    scatter: {
      marker: {
        radius: 5,
        symbol: 'circle'
      }
    }
  },
  tooltip: {
    formatter: function () {
      return '<b>' + this.x + '</b><br>Value: <b>' + this.y + '</b>';
    }
  }
};
const OverallApChart = ({ currentOrg }) => {
  const [selectedExam, setSelectedExam] = useState('1');
  const [activeSession, setActiveSession] = useState(moment().get("month") < 7 ? downcomming_year : upcomming_year)
  const dispatch = useDispatch()
  const [graphData, setGraphData] = useState(initialAPgraphData)
  const [loading, setLoading] = useState(false)
  const apChartData = useMemo(() => graphData, [graphData])

  const chatConfig = useMemo(() => {
    const g_data = cloneDeep(ApchartOptions)
    g_data.xAxis.categories = graphData.map(k=>k.label)
    g_data.series[0].data = graphData.map(k=>k.value)
    return g_data;
  }, [graphData])
  async function fetchData() {
    setLoading(true)
    try {

      const data = await dispatch(handleListApExamGraphData({
        "session": activeSession,
        "exam_type": selectedExam,
        "id": currentOrg.id
      }))
      if (Array.isArray(data)) {
        setGraphData(data)
      } else {
        setGraphData(initialAPgraphData)
      }
    } catch (error) {
      Sentry.captureException(`477 Error in fetchData: ${error}`);
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [dispatch, selectedExam, activeSession, currentOrg])

  const chart = useMemo(() => (
    <ResponsiveContainer width="100%" height={300}>
      <ScatterChart margin={{ top: 10, right: 20, left: -10, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="label" tick={{ fontSize: 12 }} interval={0} tickMargin={20} angle={-45} textAnchor="end" height={60} />
        <YAxis dataKey="value" tick={{ fontSize: 12 }} domain={[0, 'auto']} allowDecimals={false} label={{ value: 'Count', angle: -90, position: 'insideLeft', fontSize: 12 }} />
        <Tooltip formatter={(value) => [value, 'Value']} contentStyle={{ fontSize: '12px' }} labelStyle={{ fontWeight: 'bold' }} />
        <Legend wrapperStyle={{ fontSize: '12px', paddingTop: 20 }} />
        <Scatter name="AP Scores" data={apChartData} fill="#82ca9d" shape="circle" isAnimationActive={false} />
      </ScatterChart>
    </ResponsiveContainer>
  ), [apChartData])

  const exams = useExams()
  return (
    <ChartContainer >
      {loading && <ChartContainerLoader><Spin size="large" /></ChartContainerLoader>}
      <GraphRow>
        <Col xs={24} sm={24} md={12}>
          <Title>Overall AP® Spanish</Title>
        </Col>
        <GraphCol xs={24} sm={24} md={12}>
          <Select defaultValue={selectedExam} style={{ width: 120, marginBottom: '20px' }} onChange={v => {
            setSelectedExam(v)
          }} getPopupContainer={(trigger) => trigger.parentNode}>
            <Option value="1">Exam1</Option>
            <Option value="2">Exam2</Option>
            <Option value="3">Exam3</Option>
            <Option value="combine">Combine</Option>
          </Select>
          <Select defaultValue={activeSession} style={{ width: 120, marginBottom: '20px' }} onChange={v => setActiveSession(v)} getPopupContainer={(trigger) => trigger.parentNode}>
            {map(Object.keys(groupBy(exams, "session")), x => <Option value={x} key={x}>{x}</Option>)}
          </Select>
        </GraphCol>
      </GraphRow>
      {chart}
    </ChartContainer>
  );
};

const chartOptionsPi = {
  chart: {
    type: 'pie',
    height: '75%' // Adjust height as needed
  },
  title: {
    text: 'Overall Program Usage'
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  },
  plotOptions: {
    pie: {
      innerSize: '50%',
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.y}'
      },
      showInLegend: true
    }
  },
  series: [{
    name: 'Usage',
    colorByPoint: true,
    data: [
      { name: 'Anécdotas 1', y: 344, color: '#FF6384' }, // Use your own colors
      { name: 'Anécdotas Inicial 1', y: 245, color: '#36A2EB' },
      { name: 'Anécdotas 2', y: 452, color: '#FFCE56' },
      { name: 'America Ed. 4', y: 512, color: '#4BC0C0' }
    ]
  }]
};
const RANDOM_COLOR = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  COLOR.OrangeExam,
  COLOR.PinkExam,
  COLOR.blue
]
const initialbookData = [{ title: 'Anécdotas 1', count: 0, color: RANDOM_COLOR[0] },
{ title: 'Anécdotas Inicial 1', count: 0, color: RANDOM_COLOR[1] },
{ title: 'Anécdotas 2', count: 0, color: RANDOM_COLOR[2] },
{ title: 'America Ed. 4', count: 0, color: RANDOM_COLOR[3] },
{ title: 'Anécdotas Inicial 2', count: 0, color: RANDOM_COLOR[4] },
{ title: 'Anécdotas Inicial 3', count: 0, color: RANDOM_COLOR[5] },
{ title: 'Antorcha', count: 0, color: RANDOM_COLOR[6] }
]
const TabLabel = ({ color, text }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <span
      style={{
        width: 10,
        height: 10,
        backgroundColor: color,
        borderRadius: '50%',
        display: 'inline-block'
      }}
    />
    <span>{text}</span>
  </div>
);

// Wrapper to center the tabs
const CenteredTabs = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const OverallProgramUsageChart = ({ currentOrg }) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('textbooks'); // 'textbooks' | 'supplements'
  const [graphData, setGraphData] = useState(initialbookData);
  const [loading, setLoading] = useState(false);
  const [activeSession, setActiveSession] = useState(
    moment().get('month') < 7 ? downcomming_year : upcomming_year
  );
  const chartRef = useRef(null);
  const isEmpty = useMemo(() => graphData.every(item => item.count === 0), [graphData]);
  const currentSession = moment().get('month') < 7 ? downcomming_year : upcomming_year;
  const pieData = useMemo(() => graphData.map(({ title, count, color }) => ({ name: title, value: count, color })), [graphData])
  // const legendData = activeTab === 'textbooks' ? textbookLegend : supplementLegend;
  const grap_dt = useBookUsesGraphData();
  const { is_supliment_books_uses, is_text_books_uses } = useMemo(() => {
    return ({
      is_text_books_uses: Boolean(grap_dt?.text_books_uses),
      is_supliment_books_uses: Boolean(grap_dt?.supliment_books_uses),
    })
  }, [grap_dt])

  useEffect(() => {
    if (activeTab == "textbook")
      if (grap_dt && Object.keys(grap_dt).length > 0 && grap_dt.text_books_uses) {
        const { data, config } = grap_dt.text_books_uses;
        setActiveSession(config?.session)
        setGraphData(data);
      } else if (grap_dt && Object.keys(grap_dt).length > 0 && grap_dt.supliment_books_uses) {
        const { data, config } = grap_dt.text_books_uses;
        setActiveSession(config?.session)
        setGraphData(data);
      }
  }, [grap_dt, activeTab]);

  // Fetch textbook usage
  const fetchDistBookUsed = async () => {
    setLoading(true);
    try {
      const data = await dispatch(handleListbookUsed(currentOrg.id, {
        session: activeSession,
        id: currentOrg.id
      }));
      setGraphData(Array.isArray(data) ? data : initialbookData);
    } catch (e) {
      Sentry.captureException(`Error in fetchDistBookUsed: ${e}`);
      setGraphData(initialbookData);
    } finally {
      setLoading(false);
    }
  };

  const fetchSupplementsUsed = async () => {
    setLoading(true);
    try {
      const data = await dispatch(handleListSublimentUsedbookUsed(currentOrg.id, {
        session: activeSession,
        id: currentOrg.id
      }));
      setGraphData(Array.isArray(data) ? data : []);
    } catch (e) {
      Sentry.captureException(`Error in fetchSupplementsUsed: ${e}`);
      setGraphData(initialbookData);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'textbooks') {
      fetchDistBookUsed();
    } else {
      fetchSupplementsUsed();
    }
  }, [currentOrg, activeSession, activeTab]);

  const chartConfig = useMemo(() => {
    const config = cloneDeep(chartOptionsPi);
    config.series[0].data = graphData.map(({ count, color, title }) => ({
      name: title,
      y: count,
      color
    }));
    return config;
  }, [graphData]);

  const chart = useMemo(() => (
    <ResponsiveContainer width="100%" height={500}>
      <PieChart width={400} height={400}>
        {/* <Tooltip formatter={(value) => [value, 'Usage']} /> */}
        <Legend wrapperStyle={{ fontSize: '12px', paddingTop: 10 , marginTop: 10, paddingLeft: 20, paddingRight: 20 }}
            formatter={(value, entry) => {
              const total = pieData.reduce((sum, item) => sum + item.value, 0);
              const percent = ((entry.payload.value / total) * 100).toFixed(1);
              return `${value} (${percent}%)`;
            }}
        />
        <Pie 
          data={pieData} 
          dataKey="value" 
          nameKey="name" 
          activeShape={renderActiveShape}
          innerRadius={70} 
          outerRadius={110} 
          // label={({ name, value, percent }) => value > 0 ? `${name} ${(percent * 100).toFixed(0)}%` : ''} 
          labelLine={false}>
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  ), [pieData])

  return (
    <ChartContainerPi>
      {loading && (
        <ChartContainerLoader>
          <Spin size="large" />
        </ChartContainerLoader>
      )}

      <GraphRow>
        <Col xs={24} sm={24} md={12}>
          <Title>Overall Program Usage</Title>
        </Col>
        <GraphCol xs={24} sm={24} md={12}>
          <Select
            defaultValue={activeSession}
            style={{ width: 120, marginBottom: '20px' }}
            onChange={v => setActiveSession(v)}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {map(Object.keys(groupBy(useExams(), 'session')), x => (
              <Option value={x} key={x}>
                {x}
              </Option>
            ))}
            {map(Object.keys(groupBy(useExams(), 'session')))?.includes("2025-2026") ? null : (
              <Option value={currentSession} key={currentSession}>{currentSession}</Option>
            )}
          </Select>
        </GraphCol>
      </GraphRow>

     <CenteredTabs>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          tabBarGutter={40}
          centered
          tabBarStyle={{ borderBottom: 'none' }}
        >
          <Tabs.TabPane
            key="textbooks"
            tab={<TabLabel color="#000000" text="Textbooks" />}
          />
          <Tabs.TabPane
            key="supplements"
            tab={<TabLabel color="#36A2EB" text="Supplements" />}
          />
        </Tabs>
      </CenteredTabs>
      {(isEmpty && ((activeTab == "textbooks" && is_text_books_uses) || (activeTab == "supplements" && is_supliment_books_uses))) ? (
        <div style={{ textAlign: 'center', marginTop: 0 }}>
          <Title level={3} style={{ textAlign: "center" }}>No assignments yet</Title>
          <img
            src={NoAssignmentGraph}
            alt="No assignments"
            style={{ maxWidth: 300, marginBottom: 20 }}
          />
          <LegendContainer>
            {graphData.map(item => (
              <LegendItem key={item.title}>
                <ColorDot color={item.color} />
                <span>{item.title}</span>
              </LegendItem>
            ))}
          </LegendContainer>
        </div>
      ) : (
        chart
      )}
    </ChartContainerPi>
  );
};

const CeConfig = {
  chart: {
    type: 'column',
    height: 250
  },
  title: {
    text: ''
  },
  xAxis: {
    categories: ['Unit 1', 'Unit 2', 'Unit 3', 'Unit 4', 'Unit 5', 'Unit 6'],
    crosshair: true
  },
  yAxis: {
    min: 0,
    title: {
      text: 'Percentage (%)'
    }
  },
  tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.1f} %</b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true
  },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        format: '{point.y}%'
      }
    }
  },
  series: [{
    name: 'Passing Rate',
    data: [0, 0, 0, 0, 0, 0]
  }]
};

const initdata = {
  "Unidad 1": 0,
  "Unidad 2": 0,
  "Unidad 3": 0,
  "Unidad 4": 0,
  "Unidad 5": 0,
  "Unidad 6": 0
}
const order_d = ['Unidad 1', 'Unidad 2', 'Unidad 3', 'Unidad 4','Unidad 5','Unidad 6','Unidad 7','Unidad 8']
const CEChart = ({ currentOrg }) => {
  const [activeSession, setActiveSession] = useState(moment().get("month") < 7 ? downcomming_year : upcomming_year)
  const dispatch = useDispatch()
  const [graphData, setGraphData] = useState(initdata)
  const [loading, setCeLoading] = useState(false)
  const examGraphData = useContentExamGraphData()
  const [books, setBooks] = useState([{
    title: 'All',
    'value': 'all'
  }])
  const [selectedbooks, setSelectedBooks] = useState('all')
  const allbooks = useAllBook()
  const exams = useExams()
  const chartRef = useRef(null);
  const currentSession = moment().get("month") < 7 ? downcomming_year : upcomming_year;

  async function hasData() {
    return examGraphData && Object.keys(examGraphData.config).length > 0
  }
  async function fetchBook() {
    // setCeLoading(true)
    try {
      const data = await dispatch(handleContentExamBooks(currentOrg.id))
      if (Array.isArray(data)) {
        setBooks([
          {
            title: 'All',
            'value': 'all'
          },
          ...data.map((v, i) => {
            const { id, description } = v || {};
            return {
              title: `${description} (assessment)`,
              value: id
            }
          }
          )
        ])
      } else {
        setBooks([{
          title: 'All',
          'value': 'all'
        }])
      }
    } catch (e) {

    } finally {
      // setCeLoading(false)
    }
  }
  useEffect(() => {
    fetchBook()
  }, [])
  useEffect(() => {
    if (hasData()) {
      const { config, data } = examGraphData;
      setGraphData(data)
    }
  }, [examGraphData])
  const barData = useMemo(() => {
    const keys = orderBy(Object.keys(graphData), [element => order_d.indexOf(element)]);
    return keys.map(name => ({ name, value: graphData[name] }))
  }, [graphData])

  async function fetchData() {
    setCeLoading(true)
    try {

      const data = await dispatch(handleContentExamGraphData({
        "session": activeSession,
        "id": currentOrg.id,
        book_id:selectedbooks
      }))
      if (typeof data === "object") {
        setGraphData(data)
      } else {
        setGraphData(initdata)
      }
    } catch (error) {
      Sentry.captureException(`479 Error in fetchData: ${error}`);
      console.log(error, "error in fetching content")
      setGraphData(initdata)
    } finally {
      setCeLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [dispatch, activeSession, currentOrg , selectedbooks ])

  useEffect(() => {
    return () => {
      if (chartRef.current && chartRef.current.chart) {
        chartRef.current.chart.destroy();
      }
    };
  }, []);

  const chart = useMemo(() => (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={barData} margin={{ top: 10, right: 20, left: 20, bottom: 0 }} padding={{ left: 20 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} tickMargin={15} angle={-20} textAnchor="end" height={50} />
        <YAxis tick={{ fontSize: 12 }} domain={[0, 'auto']} allowDecimals={false} label={{ value: 'Percentage (%)', angle: -90, position: 'insideLeft', fontSize: 12 }} />
        <Tooltip formatter={(value) => [`${value} %`, 'Passing Rate']} />
        <Legend  wrapperStyle={{ fontSize: '12px', paddingTop: 20 }} />
        <Bar name="Passing Rate" dataKey="value" fill="#8884d8" shape="circle">
          <LabelList dataKey="value" position="top" formatter={(v) => `${v}%`} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  ), [barData])


  return (
    <ChartContainerCe>
      {loading && <ChartContainerLoader><Spin size="large" /></ChartContainerLoader>}
      <GraphRow>
        <Col xs={24} sm={24} md={16}>
          <Title>Content Exams (Passing Rates)</Title>
        </Col>
        <GraphCol span={8} md={24} lg={24} xl={24}>
          <Select defaultValue="Books" style={{ width: "auto", marginBottom: '20px' , minWidth:250 }} onChange={v => setSelectedBooks(v)} getPopupContainer={(trigger) => trigger.parentNode}>
            {books.map(x => <Option value={x.value} key={x.value}>{x.title}</Option>)}
          </Select>
          <Select defaultValue={activeSession} style={{ width: 120, marginBottom: '20px' }} onChange={v => setActiveSession(v)} getPopupContainer={(trigger) => trigger.parentNode}>
            {map(Object.keys(groupBy(exams, "session")), x => <Option value={x} key={x}>{x}</Option>)}
          </Select>
        </GraphCol>
      </GraphRow>
      {chart}
    </ChartContainerCe>
  );
};
  
const DashboardStats = ({isLoading , school , teacher , student , assignment }) => {
    return (
      <StatsContainer className="to_be_print">
        <StatCard bgColor="rgb(231,254,238)">
          <Title>Schools</Title>
          <Number>{school }</Number>
        </StatCard>
        <StatCard bgColor="rgb(252,255,227)">
          <Title>Teachers</Title>
          <Number>{teacher}</Number>
        </StatCard>
        <StatCard bgColor="rgb(239,246,254)">
          <Title>Students</Title>
          <Number>{student}</Number>
        </StatCard>
        <StatCard bgColor="rgb(252,239,239)">
          <Title>Assignments Submitted</Title>
          <Number>{assignment}</Number>
        </StatCard>
      </StatsContainer>
    );
  };
const DistrictContainer = ({
  currentUser,
  users,
  schools,
  currentOrg
}) => {
  const location = useLocation();
  							  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [teacherInfoLoading, setTeacherInfoLoading] = useState(true);
  const distDashInfo = useDistrictDashboardInfo()
  const [printloader, setPrintloader] = useState(false)
  const containerRef = useRef();
  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      try {
        await getCurrentUser();
        dispatch(handleGetOrgClasses([currentOrg, ...schools]));
        await dispatch(handleListUserBooks(currentUser?.id));
      } catch (error) {
        Sentry.captureException(`480 Error in fetchData: ${error}`);
      }
      finally {
        setLoading(false)
      }
    }
    fetchData();
  }, []);


  useEffect(() => {
    async function fetchData() {
      try {
        setTeacherInfoLoading(true);
        await Promise.all([
          dispatch(handleListDashboardInfo(currentOrg.id))
        ])
      } catch (error) {
        Sentry.captureException(`481 Error in fetchData: ${error}`);  
        console.log(error, "errror");
      } finally {
        setTeacherInfoLoading(false);
      }
    }
    fetchData();
  }, [currentOrg]);


  useEffect(() => {
    async function fetchData() {
    }
    fetchData();
  }, []);
  const validationPrint = () =>{
    addPrintableClass()
    printCall()
  }
  const printCall = useReactToPrint({
    contentRef: containerRef,
    onBeforeGetContent: async () => { setPrintloader(true) },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
    onAfterPrint: async ()=>{
      removePrintableClass()
    }
  });
  const chart1 = useMemo(()=><OverallProficiencyChart  currentOrg={currentOrg} />,[currentOrg])
  const chart2 = useMemo(()=><OverallProgramUsageChart currentOrg={currentOrg} />,[currentOrg])
  const CEChartItem = useMemo(()=><CEChart currentOrg={currentOrg} />,[currentOrg])
  const ApChartItem = useMemo(()=><OverallApChart currentOrg={currentOrg} />,[currentOrg])
  return (
    <SentryWrap>
      <DownloadDiv>
        <DownButton onClick={validationPrint}>
          {printloader ? <Loading size={12} white /> : <DownloadOutlined style={{ marginRight: '4px' }} />}
          Download
        </DownButton>
      </DownloadDiv>
      {/* <IconButton onClick={validationPrint} style={{ padding: 0, position: "absolute", right: 50 }} aria-label="download pdf" disabled={printloader} className="no-print">
        {printloader ? <Loading size={20} /> : <CloudDownloadIcon />}
      </IconButton> */}
      <div ref={containerRef} className="to_be_print">
          <DashboardStats
              isLoading
              school={distDashInfo.no_of_schools}
              teacher={distDashInfo.no_of_teachers}
              student={distDashInfo.no_of_students}
              assignment={distDashInfo.no_of_complete_submission}
              />
          <GraphRow className="to_be_print">
              <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                 {chart1} 
                 {CEChartItem}
                 {ApChartItem}
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                {chart2}
              </Col>
          </GraphRow>
      </div>
    </SentryWrap>
  );
};

//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  currentOrg: state.currentOrg,
  users: state.users,
  booksAllList: state.booksAllList,
  schools: state.schools
});

export default connect(mapStateToProps, null)(DistrictContainer);
